import { Steart } from 'app/models/core/steart.model';
import { ZeWidgetDef, ZeWidgetItem } from './vbl.ze.widgets';

export const LDPZeWidgets: ZeWidgetDef[] = [];
export const EDPZeWidgets: ZeWidgetDef[] = [];
export const EDTZeWidgets: ZeWidgetDef[] = [];
